import { render, staticRenderFns } from "./OrderInvoiceAlert.vue?vue&type=template&id=5a88f4c3&"
import script from "./OrderInvoiceAlert.vue?vue&type=script&lang=js&"
export * from "./OrderInvoiceAlert.vue?vue&type=script&lang=js&"
import style0 from "./OrderInvoiceAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports